
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CardBody, Card, Badge } from 'reactstrap'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
var moment = require('moment')

class Stats extends Component {
  render () {
    const newAppeals = this.props.admin.appeals.filter(appeal => (appeal.status === 'registered' || appeal.status === 'submitted')).length
    const appellant = this.props.admin.appeals.filter(appeal => (appeal.status === 'writing' || appeal.status === 'pending appellant response')).length
    const adjudicator = this.props.admin.appeals.filter(appeal => (appeal.status === 'submitted' || appeal.status === 'pending adjudicator response')).length
    const month = this.props.admin.appeals.filter(appeal => ((appeal.status === 'accepted' || appeal.status === 'rejected') && moment(appeal.completionTimestamp).isSame(new Date(), 'month'))).length

    return (
      <div>
        <Card>
          <CardBody>
            <p><Badge color='secondary'>{newAppeals}</Badge> New appeals</p>
            <p><Badge color='secondary'>{appellant}</Badge> Pending appellant</p>
            <p><Badge color='secondary'>{adjudicator}</Badge> Pending adjudicator</p>
            <p><Badge color='secondary'>{month}</Badge> Completed this month</p>
          </CardBody>
        </Card>
      </div>
    )
  }
}

Stats.propTypes = {
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Stats))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminDashBoard/_Stats.jsx